import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CREATE_STORE_FORM_ACTION,
  STORE_ACTION_ENUM
} from "@app/features/store-invitation/create-store/create-store.component";

@Component({
  selector: 'app-store-description-form',
  templateUrl: './store-description-form.component.html',
  styleUrls: ['./store-description-form.component.scss']
})
export class StoreDescriptionFormComponent implements OnInit {
  @Output() handelAction: EventEmitter<CREATE_STORE_FORM_ACTION> = new EventEmitter<CREATE_STORE_FORM_ACTION>();
  @Input() data: any;

  constructor(private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      description: [this.data.description ?? '', [Validators.required]],
    });
  }

  registerForm: any = FormGroup;
  submitted = false;

  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    if (this.submitted) {
      const action: CREATE_STORE_FORM_ACTION = {
        selectedIndex: 2,
        data: this.registerForm.getRawValue(),
        action: STORE_ACTION_ENUM.next
      }
      this.handelAction.emit(action)
    }
  }
}
